import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';

@Component({
  selector: 'app-spending-limit',
  templateUrl: './spending-limit.component.html',
  styleUrls: ['./spending-limit.component.scss'],
  standalone: false,
})
export class SpendingLimitComponent extends DataTypeComponent implements OnInit {
  @Input() data: any;

  @Input() editMode: boolean;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() formGroup: UntypedFormGroup;

  ngOnInit() {}
}
